export default __webpack_public_path__ + "static/media/unidos.73c1783f.png";